import { Component, OnInit, TemplateRef } from '@angular/core';
import { Branch } from './branch';
import { BranchService } from './branch.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-branch',
  templateUrl: './branch.component.html',
  styleUrls: ['./branch.component.css']
})
export class BranchComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Branch';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  branchForm: FormGroup;
  branchs: Branch[] = [];
  branchsactive: Branch[] = [];
  branch: Branch;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  branchModalRef: BsModalRef;
  operation: string;
  userid: number;
  branchid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered'

  }
  showall: boolean = true;
  showallstatus: boolean = false;
  key: string = 'branch'; //set default
  reverse: boolean = false;

  constructor(
    private branchservice: BranchService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {      
      localStorage.setItem('Branch_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('Branch_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('Branch_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('Branch_action');
    } 
  }

  ngOnInit() {
    this.checkIsMenuMapped();
    // console.log(this._menuId); console.log(this._actionRights);
    this.branchForm = this.formBuilder.group({
      branchid: [''],
      branch: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();
    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }
   
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedbranch");
    let data = arrays.find(ob => ob['name'] === 'Branch');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedbranch","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedbranch",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.branchModalRef.hide();
  }

  getAll() {
    this.branchs = [];
    this.branchsactive = [];
    this.branchservice.Get().subscribe(res => {
      this.branchs = res;
      if (this.showallstatus == true) {
        this.branchs.forEach(data => {
          if (data.active == 1) {
            this.branchsactive.push(data);
          }
        });
        this.branchs = [];
        this.branchs = this.branchsactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  getactiveinactive(showallp) {
    this.branchsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.branchs.forEach(data => {
        if (data.active == 1) {
          this.branchsactive.push(data);
        }
      });
      this.branchs = [];
      this.branchs = this.branchsactive;
    }
    else {
      this.showall = true;
      this.branchs = [];
      this.getAll();
    }
  }

  get g() { return this.branchForm.controls; }

  Post(branch: Branch) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.branchForm.invalid) {
      //console.log(this.g);
      //console.log(this.branchForm.errors);
    }
   
    if ((branch.branch.trim() == undefined) || (branch.branch.trim() == '')) {
      this.toastr.error('Branch should not be empty');
      return;
    }
   
    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    branch.branch = branch.branch.trim();
    if (this.operation == 'add') {

      branch.createdby = this.userid;
      msg = "Record Added Successfully";
      this.branchservice.Post(branch).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.branchModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      branch.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.branchservice.Put(branch).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.branchModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.branchForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.branchForm.value.active = 1;
    } else {
      this.branchForm.value.active = 0
    }
  }

  OpenConfirmTemplate(branch, template: TemplateRef<any>) {
    if (branch.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.branch = branch;

          this.Delete();

        }
       
      });

  }
  
  Delete() {

    var msg;
    if (this.branch.active == 0) {
      this.branch.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.branch.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.branch.modifiedby = this.userid;

    this.branchservice.Delete(this.branch).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }
    
  hidePopup() {
    this.branchModalRef.hide();
  }

  openBranchModal(template: TemplateRef<any>, type, branch?: Branch) {
    
    
    this.operation = type
    if (type == 'update') {
      this.branchForm.controls['branchid'].setValue(branch.branchid);
      this.branchForm.controls['branch'].setValue(branch.branch);
      this.branchForm.controls['active'].setValue(branch.active);
      this.branch = branch;
    }
    if (type == 'add') {
      this.branchForm.controls['branchid'].setValue(0);
      this.branchForm.controls['branch'].setValue('');
      this.branchForm.controls['active'].setValue(1);
    }
    this.branchModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
  }


}
